import React from 'react';
import s from '../skillsReflectionSummary.module.css';
import common from '../../../../../styles/common-styles.module.css';
import ColorBlock from '../../../../../components/ColorBlock/ColorBlock';

const getScreenText = (value) => {
  if (value === 0) {
    return 'low level of understanding';
  }
  if (value < 0.5) {
    return 'low level of understanding';
  }
  return 'intermediate to high level of understanding';
};

const getItemValue = (item) => {
  if (item === 'stronglyDisagree') {
    return 0;
  }
  if (item === 'disagree') {
    return 0.25;
  }
  if (item === 'neutral') {
    return 0.5;
  }
  if (item === 'agree') {
    return 0.75;
  }
  return 1;
};

const reflectionAnswerMap = {
  stronglyAgree: 'Strongly Agree',
  agree: 'Agree',
  neutral: 'Neutral',
  disagree: 'Disagree',
  stronglyDisagree: 'Strongly Disagree',
};

const getQuestionReponseColumn = (item) => {
  const colorBlockValue = getItemValue(item);

  return colorBlockValue >= 0.5 ? (
    <div>
      <ColorBlock
        value={colorBlockValue}
        mediumRangeMinValue={0.01}
        highRangeMinValue={0.5}
        className={s.colorBlock}
      >
        {reflectionAnswerMap[item]}
      </ColorBlock>
    </div>
  ) : (
    <div>
      <ColorBlock
        value={colorBlockValue}
        mediumRangeMinValue={0.01}
        highRangeMinValue={0.5}
        className={s.colorBlock}
        aria-label={`${getScreenText(colorBlockValue)}`}
      >
        {reflectionAnswerMap[item]}
      </ColorBlock>
      <span className={common.screenReaderText}>
        {`${getScreenText(colorBlockValue)}`}
      </span>
    </div>
  );
};

export {
  getQuestionReponseColumn,
};
